import { createNamespacedHelpers } from 'vuex'

export const eventFormStateHelper = createNamespacedHelpers('eventFormState')



// WEBPACK FOOTER //
// ./src/store/helpers/eventFormStateHelper.js